import get from 'transmute/get';
export const getTypingMessageTimeoutSeconds = get('typingMessageTimeoutSeconds');